import React, { useEffect, useState } from "react";
import EditQuiz from "./EditQuizDetails";
import { useDispatch, useSelector } from "react-redux";
import { setState, setUpdateQuizForm } from "./redux/slice";
import {
  deleteQuiz,
  getQuizzes,
  fetchQuizTypes,
  fetchSubjectBasedClassesData,
  fetchSubjects,
} from "./redux/thunk";
import { convertTermsToHtml, formatText1 } from "./utils";
import "./css/create-quiz.css";

const formatDateTime = (d) => (d ? new Date(d).toLocaleString("en-IN") : "-");

const QuizStat = ({ label, value }) => (
  <div className="qv-stat">
    <span className="qv-stat__label">{label}</span>
    <span className="qv-stat__value">
      {value === undefined || value === null || value === "" ? "-" : value}
    </span>
  </div>
);
const QuizStatus = () => {
  const user = useSelector((state) => state.authSlice.user);
  const [searchTerm, setSearchTerm] = useState("");
  // const [quizzes, setQuizzes] = useState([]);
  const [quizType, setQuizType] = useState("1");
  const [subQuizType, setSubQuizType] = useState("");
  const {
    quizzes,
    selectedQuiz,
    showPopup,
    option,
    subjectsList,
    subjectBasedClasses,
    quizTypesList,
  } = useSelector((state) => state.quizManagement);

  // const userId = J/SON.parse(localStorage.getItem("user"))?.id;
  const userId = user?.id;
  const classes = subjectBasedClasses?.data || [];
  const subjects = subjectsList?.data || [];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSubjects());
    dispatch(fetchQuizTypes());
  }, [dispatch]);

  const fetchParticipants = async (quiz, option) => {
    console.log("data to set", quiz);
    dispatch(
      setState({
        key: "selectedQuiz",
        value: {
          ...quiz, // existing quiz object
          quizType: quizType, // add quizType here
        },
      }),
    );

    if (option === "edit") {
      dispatch(
        setState({
          key: "option",
          value: option,
        }),
      );
      const data = quiz;
      const formatToISTDatetimeLocal = (utcDateStr) => {
        if (!utcDateStr) return "";
        const date = new Date(utcDateStr);
        const istString = date.toLocaleString("en-IN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });

        // Format returned like: "10/07/2025, 16:45"
        const [datePart, timePart] = istString.split(", ");
        const [day, month, year] = datePart.split("/");
        return `${year}-${month}-${day}T${timePart}`;
      };
      dispatch(
        setUpdateQuizForm({
          id: data.id || "",
          title: data.title || "",
          start: formatToISTDatetimeLocal(data.start_date),
          registrationStart: formatToISTDatetimeLocal(
            data.registration_start_date,
          ),
          registrationEnd: formatToISTDatetimeLocal(data.registration_end_date),
          totalQuestions: data.total_questions || "",
          questionDuration: data.duration_per_question || "",
          enableSkippedMarks: !!data.negative_marks_skipped,
          enableWrongMarks: !!data.negative_marks_wrong,
          correct: data.marks_per_question || "",
          registrationCost: data.registration_fee,
          registrationFeeMode: data.registration_fee > 0.0 ? "paid" : "free",
          wrong: data.negative_marks_wrong || "",
          skipped: data.negative_marks_skipped || "",
          winnerPrizes: Object.values(data.prizes || {}),
          topWinnersCount: Object.keys(data.prizes || {}).length,
          about_quiz: data.about_quiz,
          quiz_terms: data.quiz_terms,
          updated_by: userId,
          prizeDescription: data.prizes,
          description: data.description,
          class_id: String(data.class_id || ""),
          class_ids: data.class_id || [],
          className: data.className || "",
          subject_id: String(data.subject_id || ""),
          themeData:
            subQuizType === 3
              ? data?.themeDetails?.length
                ? data.themeDetails
                : data?.theme_id?.length
                  ? data.theme_id
                  : []
              : [],
          group_idd: data.group_id,
        }),
      );
      if (subQuizType === 1 || subQuizType === 2) {
        const res = await dispatch(
          fetchSubjectBasedClassesData({
            subject_id: Number(data.subject_id),
          }),
        ).unwrap();

        // Now res contains your actual data, not a promise
        dispatch(
          setUpdateQuizForm({
            key: "subjectSpecificClasses",
            value: res,
          }),
        );
      } else {
      }
    }
    dispatch(
      setState({
        key: "option",
        value: option,
      }),
    );
    dispatch(
      setState({
        key: "showPopup",
        value: true,
      }),
    );
  };
  function formatPrizeValue(v) {
    if (v === null || v === undefined || v === "") return "-";
    // If numeric string, add Rupee symbol and two decimals
    const n = Number(String(v).replace(/[^0-9.-]+/g, ""));
    if (Number.isFinite(n)) return `₹${n.toFixed(2)}`;
    return String(v);
  }

  const closePopup = () => {
    dispatch(
      setState({
        key: "selectedQuiz",
        value: null,
      }),
    );
    dispatch(
      setState({
        key: "option",
        value: "",
      }),
    );
    dispatch(
      setState({
        key: "showPopup",
        value: false,
      }),
    );
  };
  const handleDelete = async (id) => {
    try {
      // const body = { quiz_id: Number(id), updated_by: Number(userId) };

      const res = await dispatch(
        deleteQuiz({
          quiz_id: Number(id),
          school_id: user?.admin_id ?? "",
          quizType: quizType,
          user_id: user?.id ?? "",

          // quiz_id: Number(id),
          // updated_by: Number(userId),
          // quizType,
        }),
      );
      if (res) {
        console.log(res);
        alert("soft deleted the quiz");
        await dispatch(
          getQuizzes({
            quizType: quizType,
            schoolId: user?.admin_id ?? "",
          }),
        );
        window.location.reload();
      }
    } catch (er) {
      console.error(er);
    }
  };
  // const handlePublish = async (data) => {
  //   const id = data.id;
  //   try {
  //     const res = await dispatch(
  //       publishOrUnpublish({ id: id, quizType: subQuizType }),
  //     );
  //     console.log(res);

  //     // alert("res", res?.payload?.messge);
  //     // await dispatch(getQuizzes());
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  function formatText(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  const filteredQuizzes = quizzes?.filter((q) => {
    if (!searchTerm) return true; // no filter

    const term = searchTerm.toLowerCase();

    return (
      String(
        q.quiz_type === 1
          ? "Live Quiz"
          : q.quiz_type === 2
            ? "Practice Quiz"
            : "-",
      )
        .toLowerCase()
        .includes(term) ||
      String(q.title).toLowerCase().includes(term) ||
      String(q.status).toLowerCase().includes(term) ||
      new Date(q.start_date)
        .toLocaleString("en-IN")
        .toLowerCase()
        .includes(term) ||
      String(q.id).toLowerCase().includes(term)
    );
  });

  // function formatTerms(text) {
  //   if (!text) return "";

  //   const lines = text.split("\n").filter((l) => l.trim() !== "");

  //   let html = "<ol>";
  //   let inSubList = false;

  //   lines.forEach((line, idx) => {
  //     const trimmed = line.trim();

  //     // ✅ First line as heading (if it doesn’t start with a number.)
  //     if (idx === 0 && !/^\d+\./.test(trimmed)) {
  //       html = `<h3>${trimmed}</h3><ol>`;
  //       return;
  //     }

  //     // ✅ Main section (starts with number.)
  //     if (/^\d+\./.test(trimmed)) {
  //       if (inSubList) {
  //         html += "</ul>"; // close any open sublist
  //         inSubList = false;
  //       }
  //       // remove the leading number & dot
  //       const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
  //       html += `<li><strong>${withoutNum}</strong><ul>`;
  //       inSubList = true;
  //     }
  //     // ✅ Sub-point
  //     else {
  //       if (inSubList) {
  //         html += `<li>${trimmed}</li>`;
  //       } else {
  //         html += `<p>${trimmed}</p>`;
  //       }
  //     }
  //   });

  //   if (inSubList) html += "</ul>";
  //   html += "</ol>";

  //   return html;
  // }

  // const filteredList =
  //   quizType === "1"
  //     ? quizTypesList?.data.filter((e) => e.is_live === 1)
  //     : quizType === "0"
  //       ? quizTypesList?.data?.filter((e) => e.is_live === 0)
  //       : [];

  const filteredList = (quizTypesList?.data ?? []).filter((e) =>
    quizType === "1"
      ? e.is_live === 1
      : quizType === "0"
        ? e.is_live === 0
        : false,
  );
  return (
    <>
      {user?.payments?.some((payment) => payment.model_id === 3) && (
      <div className="cq-page">
        <div className="cq-shell cq-shell--single">
          <h1 className="cq-title">View / Update quizzes</h1>
          <p className="cq-subtitle">
            Pick a quiz type to see, edit or delete its quizzes.
          </p>
          <section className="cq-section">
            <div>
              {quizType !== null && (
                <div className="cq-toolbar">
                  {filteredList?.length > 0 && quizType && (
                    <span className="cq-label">Quiz type</span>
                  )}
                  <div className="cq-segment">
                    {filteredList?.map((quiz) => (
                      <label key={quiz.id}>
                        <input
                          type="radio"
                          name="subQuizType"
                          value={quiz.id}
                          checked={Number(subQuizType) === quiz.id} // numeric comparison
                          onChange={(e) => {
                            const newValue = Number(e.target.value);
                            setSubQuizType(newValue);

                            dispatch(
                              getQuizzes({
                                quizType: newValue,
                                schoolId: user?.admin_id ?? "",
                              }),
                            );

                            // getQuizzes(newValue)); // use the new value directly
                          }}
                        />
                        <span>
                          {quiz.type.charAt(0).toUpperCase() +
                            quiz.type.slice(1)}
                        </span>
                      </label>
                    ))}
                  </div>
                  {filteredQuizzes?.length > 0 && subQuizType && (
                    <span className="cq-count">
                      Matched records <strong>{filteredQuizzes?.length}</strong>
                    </span>
                  )}
                </div>
              )}

              {subQuizType && filteredQuizzes?.length > 0 ? (
                <div className="cq-table-wrap cq-list">
                  <table className="cq-table cq-table--list">
                    <tbody>
                      <tr className="bg-gray-200 text-gray-700">
                        <th className="text-center">Sl No</th>
                        <th className="text-center">Quiz Type</th>
                        <th className="text-center">Title</th>
                        <th className="text-center">Status</th>
                        {quizType === "1" && (
                          <th className="text-center">Quiz Date</th>
                        )}{" "}
                        <th className="text-center">Actions</th>
                      </tr>
                      {/* {quizzes?.map((q, index) => ( */}
                      {filteredQuizzes?.map((q, index) => (
                        <tr key={q.id} className="hover:bg-gray-100">
                          <td className="text-center">{index + 1} </td>

                          <td className="text-center">
                            {
                              quizTypesList?.data?.find(
                                (e) => e.id === subQuizType,
                              )?.type
                            }
                          </td>
                          <td className="text-center">{q.title}</td>
                          <td className="text-center">
                            <span
                            // className={`badge ${
                            //   q.status === "completed"
                            //     ? "badge-success"
                            //     : q.status === "ongoing"
                            //     ? "badge-info"
                            //     : "badge-warning"
                            // }`}
                            >
                              {q.status || "-"}
                            </span>
                          </td>
                          {quizType === "1" && (
                            <td className="text-center">
                              {" "}
                              {q.start_date
                                ? new Date(q.start_date).toLocaleString(
                                    "en-IN",
                                    {
                                      day: "2-digit",
                                      month: "long",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    },
                                  )
                                : "-"}
                            </td>
                          )}
                          <td className="text-center">
                            <img
                              width="24"
                              height="24"
                              src="https://img.icons8.com/material-rounded/24/visible.png"
                              alt="visible"
                              style={{ cursor: "pointer" }}
                              title="view quiz"
                              onClick={() => {
                                fetchParticipants(q, "view");
                                dispatch(
                                  fetchSubjectBasedClassesData({
                                    subject_id: q.subject_id,
                                  }),
                                );

                                // if (q.class_id && quizType !== "thematic") {
                                //   dispatch(
                                //     fetchSubjectsByClassThunk(Number(q.class_id))
                                //   );
                                // }
                              }}
                            />
                            {(() => {
                              const regDate = new Date(
                                q.registration_start_date,
                              );
                              const strtDate = new Date(q.start_date);
                              const now = new Date();

                              const isSameDateTime =
                                q.quiz_type === 1 || q.quiz_type === 3
                                  ? regDate.getTime() < now.getTime()
                                  : strtDate.getTime() < now.getTime();

                              // ✅ Always show buttons if quiz_type === 2

                              const shouldShow =
                                quizType === 1 ||
                                (!isSameDateTime && q.status !== "deleted");

                              return shouldShow ? (
                                <>
                                  <img
                                    width="24"
                                    height="24"
                                    style={{ cursor: "pointer" }}
                                    src="https://img.icons8.com/material-rounded/24/create-new.png"
                                    alt="create-new"
                                    title="edit quiz"
                                    onClick={() => {
                                      fetchParticipants(q, "edit");
                                    }}
                                  />
                                  <img
                                    width="24"
                                    height="24"
                                    style={{ cursor: "pointer" }}
                                    title="delete quiz"
                                    onClick={() => handleDelete(q.id)}
                                    src="https://img.icons8.com/material-sharp/24/filled-trash.png"
                                    alt="filled-trash"
                                  />
                                </>
                              ) : null;
                            })()}
                            {/* {(q.status === "active" || q.status === "inactive") && (
                        <button onClick={() => handlePublish(q)}>
                          {q.status === "active" ? "Unpublish" : "Publish"}
                        </button>
                      )} */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="cq-empty">No matching records found</p>
              )}
              {/* Custom Popup Modal */}
              {showPopup && selectedQuiz && (
                <div className="popup-overlay">
                  <div className="popup-content">
                    {/* <button onClick={closePopup}>&times;</button> */}
                    <img
                      width="20"
                      height="20"
                      src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                      alt="delete-sign--v1"
                      style={{ float: "right", cursor: "pointer" }}
                      onClick={closePopup}
                    />
                    {option === "view" ? (
                      <div className="qv">
                        <div className="qv-head">
                          {quizType !== 1 && selectedQuiz?.image_url && (
                            <img
                              className="qv-avatar"
                              src={`https://web1024.docmaster.in:5007/${selectedQuiz.image_url}`}
                              alt="quiz"
                            />
                          )}
                          <div className="qv-head__text">
                            <span className="qv-kicker">
                              {
                                quizTypesList?.data?.find(
                                  (e) => e.id === subQuizType,
                                )?.type
                              }
                            </span>
                            <h2 className="qv-title">{selectedQuiz.title}</h2>
                          </div>
                          <span
                            className={`qv-status qv-status--${
                              selectedQuiz.status || "none"
                            }`}
                          >
                            {selectedQuiz.status || "-"}
                          </span>
                        </div>

                        <div className="qv-stats">
                          {(subQuizType === 1 || subQuizType === 2) && (
                            <>
                              <QuizStat
                                label="Class"
                                value={
                                  Array.isArray(selectedQuiz.class_id)
                                    ? selectedQuiz.class_id
                                        .map(
                                          (cid) =>
                                            classes.find(
                                              (c) => c.class_id === cid,
                                            )?.class_name,
                                        )
                                        .filter(Boolean)
                                        .join(", ")
                                    : classes.find(
                                        (c) =>
                                          c.class_id === selectedQuiz.class_id,
                                      )?.class_name
                                }
                              />
                              <QuizStat
                                label="Subject"
                                value={
                                  Array.isArray(subjects)
                                    ? subjects.find(
                                        (s) =>
                                          String(s.subject_id) ===
                                          String(selectedQuiz.subject_id),
                                      )?.subject_name
                                    : null
                                }
                              />
                            </>
                          )}
                          <QuizStat
                            label="Total questions"
                            value={selectedQuiz.total_questions}
                          />
                          <QuizStat
                            label="Duration per question"
                            value={`${selectedQuiz.duration_per_question} sec`}
                          />
                          {quizType === "1" && (
                            <>
                              <QuizStat
                                label="Registration"
                                value={
                                  selectedQuiz.registration_type === "paid"
                                    ? `Paid · ₹${selectedQuiz.registration_fee}`
                                    : selectedQuiz.registration_type
                                }
                              />
                              <QuizStat
                                label="Registration opens"
                                value={formatDateTime(
                                  selectedQuiz.registration_start_date,
                                )}
                              />
                              <QuizStat
                                label="Registration closes"
                                value={formatDateTime(
                                  selectedQuiz.registration_end_date,
                                )}
                              />
                              <QuizStat
                                label="Quiz starts"
                                value={formatDateTime(selectedQuiz.start_date)}
                              />
                            </>
                          )}
                        </div>

                        {subQuizType === 3 && (
                          <div className="qv-card">
                            <h4 className="qv-card__title">Theme and group</h4>
                            <p className="qv-text">
                              Theme details:{" "}
                              {JSON.stringify(selectedQuiz?.themeDetails)}
                            </p>
                            <p className="qv-text">
                              Group details:{" "}
                              {JSON.stringify(selectedQuiz?.group_id)}
                            </p>
                          </div>
                        )}

                        <div className="qv-cols">
                          <div className="qv-card">
                            <h4 className="qv-card__title">Scoring</h4>
                            <dl className="qv-rows">
                              <div>
                                <dt>Marks per question</dt>
                                <dd>{selectedQuiz.marks_per_question}</dd>
                              </div>
                              <div>
                                <dt>Negative (wrong)</dt>
                                <dd>{selectedQuiz.negative_marks_wrong}</dd>
                              </div>
                              <div>
                                <dt>Negative (skipped)</dt>
                                <dd>{selectedQuiz.negative_marks_skipped}</dd>
                              </div>
                            </dl>
                          </div>

                          {selectedQuiz.prizes ? (
                            <div className="qv-card">
                              <h4 className="qv-card__title">Prize details</h4>
                              {typeof selectedQuiz.prizes === "object" ? (
                                <dl className="qv-rows">
                                  {(Array.isArray(selectedQuiz.prizes)
                                    ? selectedQuiz.prizes.map((p, i) => [
                                        i + 1,
                                        p,
                                      ])
                                    : Object.entries(selectedQuiz.prizes)
                                  ).map(([rank, prize]) => (
                                    <div key={rank}>
                                      <dt>Rank {rank}</dt>
                                      <dd>{formatPrizeValue(prize)}</dd>
                                    </div>
                                  ))}
                                </dl>
                              ) : (
                                <div
                                  className="qv-text"
                                  dangerouslySetInnerHTML={{
                                    __html: formatText1(
                                      String(selectedQuiz.prizes),
                                    ),
                                  }}
                                />
                              )}
                            </div>
                          ) : null}

                          {quizType === "1" &&
                            selectedQuiz.difficulty_allotment && (
                              <div className="qv-card">
                                <h4 className="qv-card__title">
                                  Difficulty mix
                                </h4>
                                <div className="qv-tags">
                                  {selectedQuiz.difficulty_allotment.map(
                                    (item, index) => (
                                      <span className="qv-tag" key={index}>
                                        {item.difficulty_level}
                                        <strong>{item.percentage}%</strong>
                                      </span>
                                    ),
                                  )}
                                </div>
                              </div>
                            )}
                        </div>

                        <div className="qv-card">
                          <h4 className="qv-card__title">About quiz</h4>
                          <p className="qv-text">
                            {selectedQuiz.about_quiz || "-"}
                          </p>
                        </div>

                        <div className="qv-card">
                          <h4 className="qv-card__title">
                            Terms &amp; conditions
                          </h4>
                          <div
                            className="qv-terms"
                            dangerouslySetInnerHTML={{
                              __html:
                                quizType === "1"
                                  ? convertTermsToHtml(selectedQuiz.quiz_terms)
                                  : quizType === "0" || quizType === "2"
                                    ? formatText(selectedQuiz?.quiz_terms)
                                    : "",
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <EditQuiz
                        allotments={selectedQuiz.difficulty_allotment}
                        quizType={subQuizType}
                      />
                    )}
                  </div>
                </div>
              )}

              {/* Simple CSS styles */}
              <style>{`
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .popup-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 95%;
    max-width: 1800px;
    height: 90vh;
    max-height: 95vh;
    overflow-y: auto;
    position: relative;
  }

  .close-btn {
    position: absolute;
    right: 12px;
    top: 10px;
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .close-btn:hover {
    color: red;
  }
`}</style>
            </div>
          </section>
        </div>
      </div>
      )}
    </>
  );
};

export default QuizStatus;
